document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-add-webwinder],[data-add-pair]');
  if (!button) return;
  const root = button.closest('[data-rp-winder-addon]');
  const status = root.querySelector('[data-addon-status]');
  const addon = Number(root.dataset.addonVariant);
  const items = button.hasAttribute('data-add-pair')
    ? [{ id: Number(root.dataset.baseVariant), quantity: 1 }, { id: addon, quantity: 1 }]
    : [{ id: addon, quantity: 1 }];
  button.disabled = true; status.textContent = 'Adding…';
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if (!response.ok) throw new Error('Cart request failed');
    status.textContent = 'Added to cart.';
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
  } catch (error) { status.textContent = 'Could not add this item. Please try again.'; }
  finally { button.disabled = false; }
});
